import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import ReactModal from "react-modal";

import { useParams } from "react-router-dom";

function VerDetalle(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  let { Id } = useParams();
  console.log(Id);

  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEstandarPorId?Id=" +
        props.idE,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);
  return (
    <Fragment>
      <button
        variant="contained"
        className="btn btn-primary"
        color="primary"
        onClick={handleOpenModalTest}
      >
        {" "}
        Ver Detalle
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Declaracion"
      >
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-body">
                  <form className="user">
                    {list.map((item) => {
                      return (
                        <div>
                          <div class="card-header py-3">
                            <h6 class="m-0 font-weight-bold text-primar">
                              Enfoque
                            </h6>
                          </div>
                          <div className="form-group row">
                            <div className="col-sm-6 mb-3 mb-sm-0">
                              <h6 class="m-0 font-weight-bold text-primary">
                                Enfoque Sistemico
                              </h6>
                              <input
                                type="text"
                                className="form-control form-control-user text-center"
                                placeholder={item.enfoqueSistemico}
                                disabled
                              ></input>
                            </div>
                            <div className="col-sm-6 ">
                              <h6 class="m-0 font-weight-bold text-primary">
                                Enfoque Proactivo
                              </h6>
                              <input
                                type="text"
                                className="form-control form-control-user text-center"
                                placeholder={item.enfoqueProactivo}
                                disabled
                              ></input>
                            </div>
                          </div>
                          <div className="form-group row">
                            <div className="col-sm-6 mb-3 mb-sm-0">
                              <h6 className="m-0 font-weight-bold text-primary">
                                Enfoque Evaluado
                              </h6>
                              <input
                                type="text"
                                className="form-control form-control-user text-center"
                                placeholder={item.enfoqueEvaluado}
                                disabled
                              ></input>
                            </div>
                          </div>

                          <div class="card-header py-3">
                            <h6 class="m-0 font-weight-bold text-primar">
                              Implementación y Despliegue
                            </h6>
                          </div>
                          <div className="form-group row">
                            <div className="col-sm-6 mb-3 mb-sm-0">
                              <h6 class="m-0 font-weight-bold text-primary">
                                Despliegue en la institución
                              </h6>
                              <input
                                type="text"
                                className="form-control form-control-user text-center"
                                placeholder={item.despliegueInstitucion}
                                disabled
                              ></input>
                            </div>
                            <div className="col-sm-6 ">
                              <h6 class="m-0 font-weight-bold text-primary">
                                Apropiación por el cliente interno y/o externo
                              </h6>
                              <input
                                type="text"
                                className="form-control form-control-user text-center"
                                placeholder={item.apropiacionCliente}
                                disabled
                              ></input>
                            </div>
                          </div>

                          <div class="card-header py-3">
                            <h6 class="m-0 font-weight-bold text-primar">
                              RESULTADO
                            </h6>
                          </div>
                          <div className="form-group row">
                            <div className="col-sm-6 mb-3 mb-sm-0">
                              <h6 class="m-0 font-weight-bold text-primary">
                                Pertinencia
                              </h6>
                              <input
                                type="text"
                                className="form-control form-control-user text-center"
                                placeholder={item.pertinencia}
                                disabled
                              ></input>
                            </div>
                            <div className="col-sm-6 ">
                              <h6 class="m-0 font-weight-bold text-primary">
                                Consistencia
                              </h6>
                              <input
                                type="text"
                                className="form-control form-control-user text-center"
                                placeholder={item.consistencia}
                                disabled
                              ></input>
                            </div>
                          </div>
                          <div className="form-group row">
                            <div className="col-sm-6 mb-3 mb-sm-0">
                              <h6 class="m-0 font-weight-bold text-primary">
                                Avance de la medición
                              </h6>
                              <input
                                type="text"
                                className="form-control form-control-user text-center"
                                placeholder={item.avanceMedicion}
                                disabled
                              ></input>
                            </div>
                            <div className="col-sm-6 ">
                              <h6 class="m-0 font-weight-bold text-primary">
                                Tendencia
                              </h6>
                              <input
                                type="text"
                                className="form-control form-control-user text-center"
                                placeholder={item.tendencia}
                                disabled
                              ></input>
                            </div>
                          </div>
                          <div className="form-group row">
                            <div className="col-sm-6 mb-3 mb-sm-0">
                              <h6 class="m-0 font-weight-bold text-primary">
                                Comparacion
                              </h6>
                              <input
                                type="text"
                                className="form-control form-control-user text-center"
                                placeholder={item.comparacion}
                                disabled
                              ></input>
                            </div>
                          </div>

                          <div className="form-group row">
                            <div className="col-sm-6 mb-3 mb-sm-0">
                              <h6 class="m-0 font-weight-bold text-primary">
                                Total
                              </h6>
                              <input
                                type="text"
                                className="form-control form-control-user text-center"
                                placeholder={
                                  (item.enfoqueSistemico +
                                    item.enfoqueProactivo +
                                    item.enfoqueEvaluado +
                                    item.despliegueInstitucion +
                                    item.apropiacionCliente +
                                    item.pertinencia +
                                    item.consistencia +
                                    item.avanceMedicion +
                                    item.tendencia +
                                    item.comparacion) /
                                  10
                                }
                                disabled
                              ></input>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </Fragment>
  );
}
export default VerDetalle;
